import { connectToStores } from 'fluxible-addons-react';
import BillingStore from '../stores/BillingStore';

const RequiresActiveSubscription = ({children, subscriptionActive}) => {
  return subscriptionActive ? children : null;
};

export default connectToStores(
  RequiresActiveSubscription,
  [BillingStore],
  (context, {children}) => ({
    subscriptionActive: context.getStore(BillingStore).isCurrentSubscriptionActive(),
    children
  })
);



// WEBPACK FOOTER //
// ./src/components/RequiresActiveSubscription.js